import { render, staticRenderFns } from "./BudgetReports.vue?vue&type=template&id=2a995ff8&scoped=true"
import script from "./BudgetReports.vue?vue&type=script&lang=js"
export * from "./BudgetReports.vue?vue&type=script&lang=js"
import style0 from "./BudgetReports.vue?vue&type=style&index=0&id=2a995ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a995ff8",
  null
  
)

export default component.exports